"use strict";export const handleSlotContent=s=>{const t=s.assignedNodes({flatten:!0}),e=s.parentElement;e&&(t.length>0?e.classList.add("slot-visible"):e.classList.remove("slot-visible"))};
//# sourceMappingURL=handleSlotContent.js.map
